import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { compose, withState, withHandlers } from 'recompose'

import { normalize } from 'helpers/StringHelper'

import { selectors as ContactUserSelectors } from 'data/contactUser'
import { selectors as UsersSelectors } from 'data/users'

import { Input } from 'components/Utils/Form'
import * as Icons from 'components/Utils/Icons'
import Avatar from 'components/Utils/Avatar'
import Loading from './Loading'
import { Text } from 'components/base'

const enhance = compose(
  connect(state => {
    return {
      updateState: ContactUserSelectors.getOrganizationContactsUpdateState(
        state
      ),
      contacts: ContactUserSelectors.getContactUsers(state),
      currentUser: UsersSelectors.getCurrentUser(state),
    }
  }),
  withState('filter', 'setFilter', ''),
  withHandlers({
    setFilter: ({ setFilter, setFilteredContacts, contacts }) => event => {
      const filter = event.target.value
      setFilter(filter)
    },
  })
)

class OAuthInvitationsForm extends Component {
  toggleContact(newEmail) {
    const { emails, setEmails } = this.props
    if (emails.includes(newEmail)) {
      setEmails(emails.filter(email => email !== newEmail))
    } else {
      setEmails(emails.concat(newEmail))
    }
  }

  renderFilter() {
    const { filter, setFilter } = this.props
    return (
      <div className="flexbox width-full border-shade-30 border-small radius-normal flexbox-centered margin-bottom-small">
        <Icons.SearchIcon
          size={16}
          className="flexbox-no-grow shade-30 margin-right-small margin-left-normal"
        />
        <Input
          style={{ paddingLeft: 8 }}
          className="width-full border-none flexbox-grow font-family-system padding-small"
          autoFocus
          tabIndex="-1"
          placeholder="search for a contact"
          onChange={setFilter}
          value={filter}
        />
      </div>
    )
  }

  render() {
    const { updateState, contacts = [], filter } = this.props
    if (contacts.size === 0 && !updateState.ongoing) {
      return null
    }

    const filteredContacts = contacts
      .filter(contact => {
        return [
          normalize(contact.displayName),
          normalize(contact.username),
          normalize(contact.email),
        ].some(element => element.includes(normalize(filter)))
      })
      .sort(contact => (!!contact.photoURL ? 1 : 0)) // useless while we give contacts photURl even if empty (backend)
    return updateState.ongoing ? (
      <Loading />
    ) : (
      <div style={{ height: 250 }}>
        {contacts.size > 0 && (
          <Text.Section className="margin-bottom-normal">
            Your team contacts
          </Text.Section>
        )}
        {this.renderFilter()}
        {Array.from(filteredContacts.values()).map(contact =>
          this.renderContact(contact)
        )}
      </div>
    )
  }

  renderContact(contact) {
    const isSelected = this.props.emails.includes(contact.email)
    return (
      <div
        key={contact.id}
        onClick={() => this.toggleContact(contact.email)}
        className={classNames(
          'pointer flexbox flexbox-align-center margin-bottom-small width-full radius-normal border-small shade-10',
          isSelected
            ? 'border-transparent'
            : 'border-shade-30 background-shade-50-on-hover background-shade-45-on-hover'
        )}
      >
        {!isSelected ? (
          <Icons.CheckboxEmptyIcon
            size={16}
            className="pointer margin-right-small margin-left-normal shade-30"
          />
        ) : (
          <Icons.CheckMarkIcon
            size={16}
            className="pointer margin-right-small margin-left-normal primary"
          />
        )}
        <div
          className={classNames(
            'flexbox flexbox-align-center padding-small width-full margin-right-medium'
          )}
        >
          <Avatar
            url={contact.photoURL}
            name={contact.displayName}
            contact={true}
            size="small"
            className="margin-right-small"
          />
          <span className="shade-10 ellipsis">{contact.email}</span>
        </div>
      </div>
    )
  }
}

export default enhance(OAuthInvitationsForm)
